module.exports = __webpack_public_path__ + "media/src/images/process_fax2-2f13d1c37664b2a5801a249a1c7e2ac0.png";